export default "__VITE_ASSET__840debfc__"